import { Component, Input, OnInit } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { Model } from '@df/catalog/model';
import { FilterAttributeOptionComponentDef } from '@df/catalog-ui/listing/filter/filter-attribute-option.component.def';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { FilterExpandableComponent } from './filter-expandable.component';
import { SwatchComponent } from '../../attribute/swatch/swatch.component';
import { CheckboxComponent } from '../../../common/form/checkbox/checkbox.component';

@Component({
    selector: 'filter-attribute-option',
    templateUrl: './filter-attribute-option.html',
    imports: [FilterExpandableComponent, SwatchComponent, CheckboxComponent]
})
export class FilterAttributeOptionComponent<T extends Model> extends FilterAttributeOptionComponentDef<T> implements OnInit {
    @Input()
    isDefault = false;

    selectedOptionsQty?: number;

    override ngOnInit(): void {
        this.onListingUpdate();
        super.ngOnInit();
    }

    clear(event: Event, option: Catalog.IAttributeOption) {
        event.preventDefault();
        this.filter.unselect(option);
    }

    private getSelectedOptionsQty(): number | undefined {
        if (this.filter?.filterType === 'attribute-option' && this.filter?.hasSelection) {
            const filterAttributeOption = this.filter as FilterAttributeOption<T>;
            const selectedOptions = filterAttributeOption.selection
                ? filterAttributeOption.options.filter(i => (filterAttributeOption?.selection?.indexOf(i.value) || 0) > -1)
                : [];
            return selectedOptions.length;
        }
        return undefined;
    }

    protected override onListingUpdate(): void {
        this.selectedOptionsQty = this.getSelectedOptionsQty();
        super.onListingUpdate();
    }
}
